
<template>
  <div class="company">
    <confirm ref="confirm"></confirm>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />

    <v-container class="my-1">
      <v-layout row Wrap>
        <v-flex xs12 sm12 lg12
          ><v-card-text
            v-text="PageTitle"
            class="subtitle-1 indigo--text"
          ></v-card-text>
        </v-flex>

      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-select
            v-model="SelectedProfile"
            :items="Profiles"
            label="Change Current Profile"
            @input="CheckProfileChange"
          ></v-select>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2> </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2> </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>



<script>
// @ is an alias to /src
import Confirm from "@/components/Confirm";
export default {
  components: { Confirm },
  data() {
    return {
      PageTitle: "Settings",
      SelectedProfile: "",
      Profiles: ["CRA", "IRR", "Friends"],
    };
  },

  created() {
    this.refreshlist();
  },

  methods: {
    async refreshlist() {
      this.progressBar = true;
      this.SelectedProfile = localStorage.getItem("CURPROFILE");
      this.progressBar = false;
    },

    async CheckProfileChange() {
      this.myJsonResp = await this.PostData(
        "ChangeProfile",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          newprofile: this.SelectedProfile,
        })
      );

      if (this.myJsonResp != "ERROR") {
        this.data = JSON.parse(this.myJsonResp);
        localStorage.setItem("CURPROFILE", this.data.DEFAULTPROFILE);
      } else {this.SelectedProfile = localStorage.getItem("CURPROFILE");}
    },
  },
};
</script>